'use client';

import { useRouter } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useLists } from '@/hooks/use-lists';
import { useLocalePath } from '@/hooks/use-locale';

export function useCreateList(onNavigate?: () => void) {
  const { t } = useTranslation();
  const router = useRouter();
  const localePath = useLocalePath();
  const { create, isCreating } = useLists();

  async function createList() {
    if (isCreating) return;
    try {
      const result = await create(t('lists.newListName'));
      onNavigate?.();
      router.push(localePath(`/my-lists/${result.id}`));
    } catch {
      toast.error(t('overview.createFailed'));
    }
  }

  return { createList, isCreating };
}
